import * as actions from './actions';
import update from 'react/lib/update';

export const initState = {
  isFetching: false,
  rootActivity: {
    pool: 0,
    registered: 0,
    id: null,
    sortedActivityIds: []
  },
  subActivities: {},
  activities: {},
  isSubmitting: false,
  isRegistrationSaved: false,
  employees: [],
  employees2: []
}

export default function (state = initState, action) {
  switch (action.type) {
    case actions.GET_ACTIVITY_REQUEST:
      return update(state, {
        isFetching: {
          $set: true
        },
        isRegistrationSaved: {
          $set: false
        }
      });
    case actions.GET_ACTIVITY_SUCCESS:
      return update(state, {
        isFetching: {
          $set: false
        },
        rootActivity: {
          $set: {
            ...action.rootActivity,
            registered: 0
          }
        },
        subActivities: {
          $set: action.subActivities
        },
        activities: {
          $set: action.activities
        },
        employees: {
          $set: action.employees
        },
        employees2: {
          $set: action.employees2
        }
      });
    case actions.UPDATE_POOL_REQUEST:
    case actions.UPDATE_POOL_FAILURE:
      return update(state, {
        rootActivity: {
          pool: {
            $set: action.val
          }
        }
      });
    case actions.UPDATE_TOTAL_REGISTERED:
    case actions.UPDATE_TOTAL_REGISTERED_INIT:
      return update(state, {
        rootActivity: {
          registered: {
            $set: action.val
          }
        }
      });
    case actions.UPDATE_TODAYSHRS:
      return update(state, {
        activities: {
          [action.id]: {
            todaysHrs: {
              $set: action.val
            }
          }
        }
      });
    case actions.SUBMIT_ACTIVITIES_REQUEST:
      return update(state, {
        isSubmitting: {
          $set: true
        }
      });
    case actions.SUBMIT_ACTIVITIES_SUCCESS:
      return update(state, {
        isSubmitting: {
          $set: false
        },
        isRegistrationSaved: {
          $set: true
        }
      });
    case actions.SUBMIT_ACTIVITIES_FAILURE:
      return update(state, {
        isSubmitting: {
          $set: false
        }
      });
    case actions.ADD_ACTIVITY_REQUEST:
      return update(state, {
        rootActivity: {
          sortedActivityIds: {
            $splice: [[0, 0, { id: action.activity.id, hasChildren: false }]]
          }
        },
        activities: {
          [action.activity.id]: {
            $set: action.activity
          }
        }
      });
    case actions.ADD_SUB_ACTIVITY_REQUEST:
      return update(state, {
        subActivities: {
          [action.parentActivityId]: {
            activityIds: {
              $splice: [[0, 0, action.activity.id]]
            }
          }
        },
        activities: {
          [action.activity.id]: {
            $set: action.activity
          }
        }
      });
    case actions.ADD_ACTIVITY_SUCCESS:
      var activity = state.activities[action.tempId];
      activity.id = action.id;
      return update(state, {
        rootActivity: {
          sortedActivityIds: {
            0: {
              id: {
                $set: action.id
              }
            }
          }
        },
        activities: {
          [action.id]: {
            $set: activity
          }
        }
      });
    case actions.ADD_SUB_ACTIVITY_SUCCESS:
      var subActivity = state.activities[action.tempId];
      subActivity.id = action.id;
      return update(state, {
        subActivities: {
          [action.parentActivityId]: {
            activityIds: {
              0: {
                $set: [action.id]
              }
            }
          }
        },
        activities: {
          [action.id]: {
            $set: subActivity
          }
        }
      });
    case actions.ADD_SUB_ACTIVITY_FAILURE:
      return update(state, {
        subActivities: {
          [action.parentActivityId]: {
            activityIds: {
              $splice: [[0, 1]]
            }
          }
        }
      });
    case actions.ADD_ACTIVITY_FAILURE:
      return update(state, {
        rootActivity: {
          sortedActivityIds: {
            $splice: [[0, 1]]
          }
        }
      });
    case actions.RENAME_ACTIVITIES_REQUEST:
      return update(state, {
        activities: {
          [action.renamedActivity.id]: {
            name: {
              $set: action.renamedActivity.name
            }
          }
        }
      });
    case actions.RENAME_ACTIVITIES_FAILURE:
      return update(state, {
        activities: {
          [action.renamedActivity.id]: {
            name: {
              $set: action.renamedActivity.oldName
            }
          }
        }
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/reducer.js